export const VARIATION = [
  'primary',
  'secondary',
  'outline',
  'naked',
  'link',
  'outline-white',
  'blue',
  'naked-inverse',
  ''
]

export const SIZE = [
  'small',
  'large',
  'extra-small',
  ''
]

export const FLOATING = [
  'left',
  'right',
  'center',
  ''
]
